// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function paraguayanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'py',
    document: userInputValues['paraguayanDocument'],
    zipcode: userInputValues['paraguayanZipcode'],
    state: userInputValues['paraguayanState'],
    city: userInputValues['paraguayanCity'],
    address: userInputValues['paraguayanAddress'],
    street_number: userInputValues['paraguayanStreetNumber'],
    street_complement: userInputValues['paraguayanStreetComplement'],
    phone_number: userInputValues['paraguayanPhoneNumber'],
  };
}
